import gql from "graphql-tag"

const START_ORDER_LINE_MODIFICATION = gql`
  mutation startModificationOrderLines($modificationId: ID!, $input: InputOrderModificationOrderLinesStart!) {
    Order {
      startOrderModificationOrderLines(modificationId: $modificationId, input: $input) {
        status
      }
    }
  }
`

export default START_ORDER_LINE_MODIFICATION
